(function () {
  const pages = ["/pages/lp-trial-sem", "/pages/lp-trial-sns", "/pages/lp-trial-newsletter", "/pages/lp-trial-dm", "/pages/lp-trial-flyer", "/pages/lp-trial-sem/", "/pages/lp-trial-sns/", "/pages/lp-trial-newsletter/", "/pages/lp-trial-dm/", "/pages/lp-trial-flyer/"]; 

  if (!pages.includes(location.pathname)) {
    // exit if page doesn't match
    return;
  }


  // page handle
  let landingPageSource = location.pathname.split("/pages/")[1];
  const lastChar = landingPageSource.substr(-1); // Selects the last character
  if (lastChar === '/') {         // If the last character is not a slash
    landingPageSource = landingPageSource.replace('/', '');
  }
  console.log(landingPageSource);
  // tag cart/order by landing page handle
  let xhr = new XMLHttpRequest();
  xhr.open("POST", "/cart/update.js", true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send(
    JSON.stringify({
      attributes: {
        __source: landingPageSource,
      },
    })
  );

})();